import React, { useState, useEffect } from "react"
import AccordionOld from "../../molecules/AccordionOld"
import "./styles.scss"
const TabsHorizontal = ({ slides, isDesktop }) => {
  const [activeTab, setActiveTab] = useState(0)
  const [tabHeight, setTabHeight] = useState(null)

  const handleTab = tab => {
    setActiveTab(tab)
  }
  let tabsHeight = []

  useEffect(() => {
    let tabs = document.querySelectorAll(".tabsHorizontal__content > div")
    tabs = [...tabs]
    tabs.forEach(tab => {
      if (tab && tab.clientHeight > tabsHeight) {
        tabsHeight = tab.clientHeight
      }
    })
    setTabHeight(tabsHeight)
  }, [])
  if (isDesktop) {
    return (
      <div className="tabsHorizontal">
        <ul className="tabsHorizontal__navigation">
          {slides.map((tab, i) => {
            return (
              <li
                data-content={tab.title}
                onClick={() => {
                  handleTab(i)
                }}
                key={i}
                className={`tab ${i !== activeTab ? "" : "active"}`}
              >
                {tab.title}
              </li>
            )
          })}
        </ul>
        <div className="tabsHorizontal__content">
          {slides.map((tab, i) => {
            return (
              <div
                style={{ minHeight: tabHeight }}
                key={i}
                className={` ${i !== activeTab ? "" : "active"}`}
              >
                <p>{tab.description}</p>
              </div>
            )
          })}
        </div>
      </div>
    )
  } else {
    return <AccordionOld tabs={slides} />
  }
}
export default TabsHorizontal
